module.exports = __webpack_public_path__ + "img/icon-tongguo.5f307428.png";